import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 消息中心查询组织结构树
  deptUserTree(id) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDept/deptUserTree/' + id,
      method: 'get'
    })
  },
  // 查询组织结构树
  deptTree(id) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDept/deptTree/' + id,
      method: 'get'
    })
  },
  // 消息中心查询总部/公司部门结构树
  companyUserTree() {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDept/companyUserTree',
      method: 'get'
    })
  },
  // 查询总部/公司部门结构树
  companyTree() {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDept/companyTree',
      method: 'get'
    })
  },

  // 部门下的子部门和此部门下的人员列表
  mobilepersondept(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/mobile/person/dept',
      method: 'get',
      params: args
    })
  },
  // 人员详情
  mobilepersondetail(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/mobile/person/detail',
      method: 'get',
      params: args
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/archivesmanagement/index.js